<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn search-picker">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">查询时间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getTableData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" show-summary :summary-method="total" border style="width: 100%">
                    <el-table-column show-overflow-tooltip prop="Source" label="请求渠道"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="RequestTotal" label="总请求数"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="NewRequestTotal" label="新增请求数"></el-table-column>
                    <el-table-column fixed="right" label="操作">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button title="请求记录" size="mini" type="text" @click="opRecords(scope.row.Source)">请求记录</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            recordVisible:false,
            vin: '',
            dateTimes: [],
            searchData: {
                EntpId: this.$util.getLocalStorage('userMsg').EntpId,
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            },
            tableData: [],
            tableDataLength: 0,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created() {
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1-1, 0);
        this.dateTimes.push(date1);
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1];
        let date2 = new Date(year2, month2, day2, 0);
        this.dateTimes.unshift(date2);

        this.searchData.StartDate = date2;
        this.searchData.EndDate = date1;
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        renderHeader(h, { column }) {
            const goodsCount = [
                h(
                    'div',
                    {
                        slot: 'content',
                        style: 'margin-bottom:5px'
                    },
                    '仅是绑定单据时系统自动关联车型与配件的总数，'
                ),
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '不包含在商品新增或编辑页面中主动勾选的关联数'
                )
            ];
            return h('span', [
                h(
                    'el-tooltip',
                    {
                        props: {
                            placement: 'bottom'
                        }
                    },
                    [
                        goodsCount,
                        h('i', {
                            class: 'el-icon-warning-outline',
                            style: 'color:orange;margin-right:5px;'
                        })
                    ]
                ),
                h('span', column.label)
            ]);
        },
        // 重置表单
        resetSearch() {
            this.searchData.StartDate = '';
            this.searchData.EndDate = '';
            this.searchData.page = 1;
            this.searchData.limit = this.commonPageSize;
            this.dateTimes = [];
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/DataStatistics/VINRequestStatistics',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.tableData = data.DataList;
                        this.tableDataLength = res.count;
                    } else if (res.errcode != 201 && !data) {
                        this.tableData = [];
                        this.tableDataLength = 0;
                    }
                })
                .catch(() => {});
        },
        total(param) {
            const { columns, data } = param
            const sums = []
            columns.forEach((column, index) => {
                if (index === 0) {
                sums[index] = '合计';
                return;
                }
                if(index === 3){
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (column.property != 'price') {
                sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                    return prev + curr;
                    } else {
                    return prev;
                    }
                }, 0);
                sums[index];
                }
            });
            return sums
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            }
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        opRecords(source) {
            this.$router.push(`/statistics/vinStat?source=${source}`);
        },
        closeRecordDialog(){
            this.vin = '';
            this.recordVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.el-table td, .el-table th{
    padding: 4px 0 !important;
}
</style>